module.exports = __webpack_public_path__ + "img/join_group.6c199777.png";